import { createDemo } from '@mui/internal-core-docs/utils/createDemo';
import ProminentAppBar from './ProminentAppBar';
import ClientProvider from './client';
export default createDemo(import.meta.url, ProminentAppBar, { ClientProvider, precompute: {
  "Default": {
    "url": "file:///opt/build/repo/docs/data/material/components/app-bar/demos/prominent/ProminentAppBar.tsx",
    "fileName": "ProminentAppBar.tsx",
    "language": "tsx",
    "source": {
      "type": "root",
      "children": [
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "import { styled } from '@mui/material/styles';\nimport AppBar from '@mui/material/AppBar';\nimport Box from '@mui/material/Box';\nimport Toolbar from '@mui/material/Toolbar';\nimport IconButton from '@mui/material/IconButton';\nimport Typography from '@mui/material/Typography';\nimport MenuIcon from '@mui/icons-material/Menu';\nimport SearchIcon from '@mui/icons-material/Search';\nimport MoreIcon from '@mui/icons-material/MoreVert';\n\nconst StyledToolbar = styled(Toolbar)(({ theme }) => ({\n  alignItems: 'flex-start',\n  paddingTop: theme.spacing(1),\n  paddingBottom: theme.spacing(2),\n  // Override media queries injected by theme.mixins.toolbar\n  '@media all': {\n    minHeight: 128,\n  },\n}));\n\nexport default function ProminentAppBar() {\n  return (\n    <Box sx={{ flexGrow: 1 }}>\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "dataFrameType": "focus-unfocused",
            "dataFrameIndent": 3,
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "      <AppBar position=\"static\">\n        <StyledToolbar>\n          <IconButton\n            size=\"large\"\n            edge=\"start\"\n            color=\"inherit\"\n            aria-label=\"open drawer\"\n            sx={{ mr: 2 }}\n          >\n            <MenuIcon />\n          </IconButton>\n          <Typography\n            variant=\"h5\"\n            noWrap\n            component=\"div\"\n            sx={{ flexGrow: 1, alignSelf: 'flex-end' }}\n          >\n            MUI\n          </Typography>\n          <IconButton size=\"large\" aria-label=\"search\" color=\"inherit\">\n            <SearchIcon />\n          </IconButton>\n          <IconButton\n            size=\"large\"\n            aria-label=\"display more actions\"\n            edge=\"end\"\n            color=\"inherit\"\n          >\n            <MoreIcon />\n          </IconButton>\n        </StyledToolbar>\n      </AppBar>\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "    </Box>\n  );\n}\n"
            }
          ]
        }
      ],
      "data": {
        "totalLines": 58,
        "focusedLines": 0,
        "collapsible": true
      }
    },
    "fallback": [
      [
        "span",
        "frame",
        "import { styled } from '@mui/material/styles';\nimport AppBar from '@mui/material/AppBar';\nimport Box from '@mui/material/Box';\nimport Toolbar from '@mui/material/Toolbar';\nimport IconButton from '@mui/material/IconButton';\nimport Typography from '@mui/material/Typography';\nimport MenuIcon from '@mui/icons-material/Menu';\nimport SearchIcon from '@mui/icons-material/Search';\nimport MoreIcon from '@mui/icons-material/MoreVert';\n\nconst StyledToolbar = styled(Toolbar)(({ theme }) => ({\n  alignItems: 'flex-start',\n  paddingTop: theme.spacing(1),\n  paddingBottom: theme.spacing(2),\n  // Override media queries injected by theme.mixins.toolbar\n  '@media all': {\n    minHeight: 128,\n  },\n}));\n\nexport default function ProminentAppBar() {\n  return (\n    <Box sx={{ flexGrow: 1 }}>\n"
      ],
      [
        "span",
        "frame",
        {
          "dataFrameType": "focus-unfocused",
          "dataFrameIndent": 3
        },
        "      <AppBar position=\"static\">\n        <StyledToolbar>\n          <IconButton\n            size=\"large\"\n            edge=\"start\"\n            color=\"inherit\"\n            aria-label=\"open drawer\"\n            sx={{ mr: 2 }}\n          >\n            <MenuIcon />\n          </IconButton>\n          <Typography\n            variant=\"h5\"\n            noWrap\n            component=\"div\"\n            sx={{ flexGrow: 1, alignSelf: 'flex-end' }}\n          >\n            MUI\n          </Typography>\n          <IconButton size=\"large\" aria-label=\"search\" color=\"inherit\">\n            <SearchIcon />\n          </IconButton>\n          <IconButton\n            size=\"large\"\n            aria-label=\"display more actions\"\n            edge=\"end\"\n            color=\"inherit\"\n          >\n            <MoreIcon />\n          </IconButton>\n        </StyledToolbar>\n      </AppBar>\n"
      ],
      [
        "span",
        "frame",
        "    </Box>\n  );\n}\n"
      ]
    ],
    "totalLines": 58,
    "focusedLines": 0,
    "collapsible": true,
    "externals": [
      "@mui/material/styles",
      "@mui/material/AppBar",
      "@mui/material/Box",
      "@mui/material/Toolbar",
      "@mui/material/IconButton",
      "@mui/material/Typography",
      "@mui/icons-material/Menu",
      "@mui/icons-material/Search",
      "@mui/icons-material/MoreVert"
    ]
  }
}, loadPrecompute: () => import("./index.ts?mui-deferred-precompute").then((module) => module.default) });
